<template>
  <div
    class="flex items-center justify-center shrink-0 rounded-md"
    :class="[size, ui?.wrapper]"
  >
    <slot :class="ui?.icon">
      <Icon v-if="icon" :name="icon" :class="ui?.icon" />
    </slot>
  </div>
</template>

<script lang="ts" setup>
import type { Component } from 'vue'

defineOptions({
  name: 'IconBadge',
})

withDefaults(
  defineProps<{
    size?: string
    icon?: string | Component
    ui?: {
      wrapper?: string
      icon?: string
    }
  }>(),
  {
    size: 'size-6',
    icon: undefined,
    ui: () => ({}),
  },
)
</script>

<style lang="scss" scoped></style>
